import React from 'react';

import PageLayout from '../../components/layout/PageLayout';
import ProfileIndex from '../../components/user/ProfileIndex';

const ProfilePage = () => {
  return (
    <PageLayout>
      <ProfileIndex />
    </PageLayout>
  );
};

export default ProfilePage;
